<template>
  <div
    class="modal-alert-footer"
    :class="{
      'modal-show': modalAlertFooterShow,
      'modal-hide': !modalAlertFooterShow
    }"
  >
    <div class="text">{{ modalAlertFooterText }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'modal-alert-footer',
  data() {
    return {
      modalActive: false
    }
  },
  computed: {
    ...mapGetters([
      'modalAlertFooterShow',
      'modalAlertFooterText',
      'modalAlertFooterPropData'
    ])
  }
}
</script>

<style lang="scss" scoped>
.modal-alert-footer {
  position: fixed;
  width: 100%;
  height: 100px;
  background-color: #fff5dc;
  bottom: 0;
  display: none;
  z-index: 1000;
  transition: all;
  .text {
    position: absolute;
    margin: auto;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 90%;
    height: 50px;
    text-align: center;
  }
}

.modal-show {
  display: block;
  /*animation: showMsgAlert ease-in-out;*/
  /*animation-duration: 2s;*/
  /*animation-delay: 2s;*/
}

.modal-hide {
  display: none;
  /*animation: showMsgAlert ease-in-out;*/
  /*animation-duration: 2s;*/
  /*animation-delay: 2s;*/
  /*animation-fill-mode: revert;*/
}

@keyframes showMsgAlert {
  from {
    opacity: 0;
    bottom: -100px;
  }

  to {
    opacity: 1;
    bottom: 0;
  }
}
</style>
